import { SiteDjuYear } from '@/queries/site-dju-year.query'

export function getDjuMinMaxYear({ djuYears, sites }: { djuYears: SiteDjuYear; sites?: Array<string> }): { minYear: number; maxYear: number } {
  const selectedDjuYears = sites ? djuYears.filter((djuYear) => sites.includes(djuYear.siteId.toString())) : djuYears

  const minYear = Math.min(
    ...selectedDjuYears.map((djuYear) => {
      return Math.min(...djuYear.djuYears.map((dju) => dju))
    }),
  )

  const maxYear = Math.max(
    ...selectedDjuYears.map((djuYear) => {
      return Math.max(...djuYear.djuYears.map((dju) => dju))
    }),
  )

  return { minYear, maxYear }
}
